import script from "./UiButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiButton.vue?vue&type=script&setup=true&lang=ts"

import "./UiButton.vue?vue&type=style&index=0&id=2cac7dae&lang=sass"

const __exports__ = script;

export default __exports__